module.exports = __webpack_public_path__ + "static/Schoeffel_Visuals-b6f2b9995ab78e81a9c35b502dfec1d8.png";